namespace TR {

    class TextFader {

        height: number;
        showContent: boolean = true;
        showExpanderLink: boolean = true;

        constructor() {
        }

        init (contentHeight: number): void {

            console.log('text fader: ' + contentHeight);
            //if there isn't enough content remove the more less links
            this.showContent = !(contentHeight > this.height);
            this.showExpanderLink = !this.showContent;
        }

    }

    angular
        .module('TR')
        .directive('textFader', (): ng.IDirective => {
            return {
                scope: {
                    height: '='
                },
                templateUrl: 'partials/home/directivetemplate?type=TextFader',
                bindToController: true,
                controller: TextFader,
                controllerAs: 'tf',
                link: (scope: ng.IScope, el: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrl:TextFader) => {

                    setTimeout(function () {
                        // angular finished its thing we can get the height
                        ctrl.init(el.find(' > .content').outerHeight());
                    }, 0);
                },
                replace: true,
                transclude: true
            };
        });
}
